/**
 * @typedef module:Media.AudioService.AudioLogTypeEnum
 * @description Every value emitted by a subscription to 'start' is tagged with one of these values,
 *     which clients can use to process the values
 * @property {String} autoPlay
 * @property {String} badParams
 * @property {String} codecError
 * @property {String} init
 * @property {String} keepAliveConfirmed
 * @property {String} keepAliveFailed
 * @property {String} loadedWorker
 * @property {String} notAuthorized
 * @property {String} offline
 * @property {String} socketCreated
 * @property {String} socketInitRequested
 * @property {String} socketInitConfirmed
 * @property {String} socketOpenConfirmed
 * @property {String} socketOpenFailed
 * @property {String} socketClosed
 * @property {String} socketCreateFailed
 * @property {String} socketError
 * @property {String} streamFirstPacketReceived
 * @property {String} streamStartConfirmed
 * @property {String} streamStartFailed
 * @property {String} streamStartRequested
 * @property {String} talkbackError
 * @property {String} viewerSessionCreated
 * @property {String} viewerSessionFailed
 * @property {String} workersNotSupported
 */

const AudioLogTypeEnum = Object.freeze({
    autoPlay: 'autoPlay',
    badParams : 'badParams',
    badServerResponse: 'badServerResponse',
    codecError: 'codecError',
    init: 'init',
    keepAliveConfirmed: 'keepAliveConfirmed',
    keepAliveFailed: 'keepAliveFailed',
    loadedWorker: 'loadedWorker',
    notAuthorized : 'notAuthorized',
    offline: 'offline',
    socketCreated: 'socketCreated',
    socketInitRequested: 'socketInitRequested',
    socketInitConfirmed: 'socketInitConfirmed',
    socketOpenConfirmed: 'socketOpenConfirmed',
    socketOpenFailed: 'socketOpenFailed',
    socketClosed: 'socketClosed',
    socketCreateFailed: 'socketCreateFailed',
    socketError: 'socketError',
    streamFirstPacketReceived: 'streamFirstPacketReceived',
    streamStartConfirmed: 'streamStartConfirmed',
    streamStartFailed: 'streamStartFailed',
    streamStartRequested: 'streamStartRequested',
    talkbackError: 'talkbackError',
    viewerSessionCreated: 'viewerSessionCreated',
    viewerSessionFailed: 'viewerSessionFailed',
    workersNotSupported: 'workersNotSupported'
});

export default AudioLogTypeEnum;
